var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showComments
    ? _c("div", { staticClass: "row comments-list" }, [
        _c("div", { staticClass: "col-md-6 col-12" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "px-0" },
            _vm._l(_vm.commentsList, function(comment, key) {
              return _c("li", { key: key }, [
                _c(
                  "div",
                  { staticClass: "py-2 mb-2" },
                  [
                    _c("knowledge-article-comment", {
                      attrs: { "comment-data": comment }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "reply-thread-wrapper d-flex flex-row pt-2"
                      },
                      [
                        _vm.commentHasChildren(comment)
                          ? _c(
                              "div",
                              { staticClass: "reply-arrow-wrapper mr-3" },
                              [
                                _c("img", {
                                  staticClass: "reply-arrow-icon",
                                  attrs: {
                                    src: require("./../../assets/reply-arrow.svg")
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "px-0" },
                          _vm._l(comment.formattedChildComments, function(
                            childComment,
                            key
                          ) {
                            return _c(
                              "li",
                              { key: key, staticClass: "pb-2" },
                              [
                                _c("knowledge-article-comment", {
                                  attrs: {
                                    "comment-data": childComment,
                                    "is-admin": true
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "comments-title-container pb-2" }, [
      _c("h6", [_vm._v("Comments")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8341178", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8341178","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeArticleComments.vue
// module id = null
// module chunks = 